export interface Environment {
  portalUsUrl: string;
  portalCaUrl: string;
  apiUsBaseUrl: string;
  apiCaBaseUrl: string;
  supportEmail: string;
}

export const environment: Environment = {
  portalUsUrl: 'https://portal.dev.us.lifespeak.com',
  portalCaUrl: 'https://portal.dev.us.lifespeak.com',
  apiUsBaseUrl: 'https://portal-api2.dev.us.lifespeak.com',
  apiCaBaseUrl: 'https://portal-api2.dev.us.lifespeak.com',
  supportEmail: 'member.support@lifespeak.com'
};
